import * as _ from 'lodash';
import SiteResource from '../models/site-resource';
import SiteService from '../services/site.service';

angular
  .module('ciApp.services')
  .service('SiteSwitcherService', [
    '$rootScope',
    '$http',
    '$q',
    'localStorageService',
    'PermissionService',
    'SiteService',
    SiteSwitcherService
  ]);

function SiteSwitcherService(
  $rootScope,
  $http,
  $q,
  localStorageService,
  PermissionService,
  SiteService
) {
  this.availableSites = function() {
    return _.chain(localStorageService.get('availableSites'))
      .map(site => new SiteResource(site))
      .orderBy('name')
      .value();
  };

  this.saveSites = function(sitesData) {
    localStorageService.set('availableSites', sitesData);
    var desiredSiteId = sitesData[0].id;
    if (angular.isObject(this.currentSite())) {
      desiredSiteId = this.currentSite().id;
    }
    $rootScope.$broadcast('sitesUpdated');
    return this.changeSite(desiredSiteId);
  };

  this.currentSite = function() {
    var site = localStorageService.get('currentSite');
    return site ? new SiteResource(site) : undefined;
  };

  this.savePermissionsForSite = function(site) {
    return PermissionService.getAll({ site: site.id }).then(permissions => {
      var available = this.availableSites();
      _.remove(available, site);

      site.permissions = permissions;
      available.push(site);

      localStorageService.set('availableSites', available);
      localStorageService.set('currentSite', site);
      return site;
    });
  };

  this.changeSite = function(siteId) {
    if (_.get(this.currentSite(), 'id') == siteId) {
      // We're already there. Done
      return $q.resolve(this.currentSite());
    }
    if (_.isNil(siteId)) {
      return $q.reject('did not change site');
    }

    var available = this.availableSites();
    var selected = _.find(available, { id: siteId });

    if (_.isNil(selected)) {
      return $q.reject('did not change site');
    }

    if (_.isEmpty(selected.permissions)) {
      return this.savePermissionsForSite(selected);
    } else {
      localStorageService.set('currentSite', selected);
      return $q.resolve(this.currentSite());
    }
  };

  this.resetAllSites = function() {
    return SiteService.getAll().then(siteData => {
      return this.saveSites(siteData);
    });
  };
}



// WEBPACK FOOTER //
// ./common/services/site_switcher.service.js